import React from 'react';

const Home = () => (
  <section id="home" className="container my-5">
    <div className="card shadow-sm p-4">
      <h2 className="mb-3">Welcome!</h2>
      <p>This site will guide you on your journey to becoming a full stack developer, covering essential skills, tools, and resources.</p>
      <p>Whether you're just starting out or looking to advance your career, you'll find step-by-step guides, curated resources, and practical tips to help you master both front-end and back-end development.</p>
      <p>Full stack developers are in high demand, as they can build complete web applications from scratch, handle databases, APIs, user interfaces, and everything in between. Here, you'll learn about:</p>
      <ul>
        <li>Core web technologies: HTML, CSS, JavaScript</li>
        <li>Popular frameworks and libraries</li>
        <li>Backend development and databases</li>
        <li>APIs and web services</li>
        <li>Deployment and DevOps basics</li>
        <li>Best practices and career tips</li>
      </ul>
      <p>Start exploring the menu above to begin your full stack journey!</p>
    </div>
  </section>
);

export default Home; 